














import addressWithLookup from '@/components/address-with-lookup.vue';
import { ClientAccount } from '@/shared/clients/client-account';
import { Validator } from 'vee-validate';
import { Component, Inject, Prop, Vue } from 'vue-property-decorator';

@Component({
    components: {
        addressWithLookup,
    },
})
export default class ClientAddressDetails extends Vue {
    @Inject('$validator') public $validator!: Validator;
    @Prop({ required: true }) public client!: ClientAccount;
}
